module.exports = __webpack_public_path__ + "templates.address_module-d382effb.html";